import { storeToRefs } from 'pinia';

export default async function useHotjarIdentify() {
  const userStore = useUserStore();
  const { user, inPersonification } = storeToRefs(userStore);
  const scoreSolfacilPlus = ref(userStore.getScoreSolfacilPlus()!);

  watch(
    () => user.value,
    newUser => {
      if (newUser && 'partner' in newUser) {
        const userPayload = {
          phone: newUser.partner?.recipient?.phone,
          nome: newUser.fullName,
          profile: newUser?.profile,
          level: scoreSolfacilPlus?.value?.level,
          document: newUser?.partner?.cnpj,
          state: newUser?.partner?.address?.state || '',
          zipcode: newUser.partner?.address?.zipcode,
          city: newUser.partner?.address?.city,
          isPersonification: inPersonification.value,
          partnerId: newUser?.partner?.id,
        };

        hotjar.identify(newUser?.id, userPayload);
      }
    },
    {
      immediate: true,
    },
  );
}
